import React from "react";
import logo from "../images/logo.png";
import twitter from "../images/twitter.png";
import discord from "../images/discord.png";
import instagram from "../images/instagram.png";
import { Script } from "gatsby";

type Props = {};

export default function Footer({}: Props) {
  const footerLinks = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Features",
      link: "/#features",
    },
    {
      title: "How it works",
      link: "/how-it-works",
    },
    {
      title: "Help",
      link: "mailto:hello@nftclaimer.xyz",
    },
    {
      title: "Imprint",
      link: "/imprint",
    },
    {
      title: "Terms",
      link: "/terms.html",
      target: "_blank noreferrer noopener",
    },
    {
      title: "Privacy",
      link: "/privacy.html",
      target: "_blank noreferrer noopener",
    },
  ];

  const socials = [
    {
      title: "Twitter",
      link: "https://twitter.com/nftclaimerxyz",
      image: twitter,
    },
    {
      title: "Discord",
      link: "https://discord.gg/UgDF8NKf",
      image: discord,
    },
  ];

  return (
    <>
      <Script>const BADGE_ID = "1f3ab776ade283e0";</Script>
      <Script
        type="text/javascript"
        src="https://static.alchemyapi.io/scripts/badge/alchemy-badge.js"
      />
      <footer>
        <div className="bg-footerBackground py-16 px-8 md:px-24 text-white text-center grid grid-cols-10 gap-8 md:gap-8">
          <img src={logo} className="h-6 col-span-10 lg:col-span-2" />
          <div className="col-span-full lg:col-span-7 gap-4 md:gap-8 grid grid-cols-2 lg:grid-cols-8 justify-center mt-8 md:mt-0">
            {footerLinks.map((link) => {
              return (
                <div>
                  <a href={link.link} target={link.target}>
                    {link.title}
                  </a>
                </div>
              );
            })}
          </div>
          <div className="col-span-full lg:col-span-1 flex justify-center lg:flex-row gap-6 lg:justify-end">
            {socials.map((social) => {
              return (
                <a href={social.link}>
                  <img src={social.image} className="w-8" />
                </a>
              );
            })}
          </div>
          <div className="text-gray-400 text-center col-span-full text-sm flex flex-col md:flex-row justify-between items-center">
            <a href="#">
              <img
                onClick={() => {
                  const window = globalThis as any;
                  window.logBadgeClick();
                }}
                id="badge-button"
                className="w-[240px] h-[53px]"
                src="https://static.alchemyapi.io/images/marketing/badgeLight.png"
                alt="Alchemy Supercharged"
              />
            </a>
            <p>© 2022 Butleroy GmbH</p>
          </div>
        </div>
      </footer>
    </>
  );
}
